module.exports = __webpack_public_path__ + "static/img/HOME-2.978a9618.jpg";